// extracted by mini-css-extract-plugin
export const section = "sodelavci-module--section--1aBz0";
export const container = "sodelavci-module--container--2U2eM";
export const pageContent = "sodelavci-module--pageContent--36k_W";
export const footer = "sodelavci-module--footer--2poVM";
export const modal = "sodelavci-module--modal--9MTXB";
export const sContainer = "sodelavci-module--sContainer--3nVLH";
export const wrap = "sodelavci-module--wrap--3yyxS";
export const sodelavec = "sodelavci-module--sodelavec--F261a";